import { Suspense } from "react"
import { Outlet, BrowserRouter as Router, Routes, Route, Link } from "react-router-dom"
import Layout from "../common/Layout/Layout"
import { Result } from "antd"
import SuspenseComponent from "./SuspenseComponent"
import pageList from "./PageList"
import Login from "../../pages/Authen/Login"
import { useStore } from "../ui"

function ProtectedRoute() {
  return (
    <Layout>
      <Suspense fallback={<SuspenseComponent />}>
        <Outlet />
      </Suspense>
    </Layout>
  )
}

export default function Routers() {
  const { token, menus, authLoaded } = useStore()

  // Wait for auth state to be determined
  if (!authLoaded) {
    return (
      <div style={{ 
        display: "flex", 
        justifyContent: "center", 
        alignItems: "center", 
        height: "100vh",
        background: "#f0f0f0"
      }}>
        <div style={{ textAlign: "center" }}>
          <div style={{ 
            width: 40, 
            height: 40, 
            border: "4px solid #0f766e", 
            borderTopColor: "transparent",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
            margin: "0 auto 16px"
          }} />
          <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
          <p>Đang tải...</p>
        </div>
      </div>
    )
  }

  // Auth loaded - check if user has token (from cookie or login)
  if (!token) {
    return (
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Routes>
          <Route path="*" element={<Login />} />
        </Routes>
      </Router>
    )
  }

  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Routes>
        <Route element={<ProtectedRoute />}>
          {pageList().map(({ Element, code, path }, key) => {
            const item = menus?.find((i) => i.code === code || (code === "SURVEILLANCE" && (i.code === "SURVEILLANCE_DASHBOARD" || String(i.code || "").startsWith("SURVEILLANCE"))))
            return <Route path={path} key={key} element={<Element tabs={item?.tab} />} />
          })}
          <Route path="*" element={<NotLoadAuthorization />} />
        </Route>
      </Routes>
    </Router>
  )
}

const NotLoadAuthorization = () => {
  return (
    <div className="__content">
      <Result
        status="404"
        title="404"
        subTitle="Sorry, the page you visited does not exist."
        extra={<Link to="/dashboard">Về trang chủ</Link>}
      />
    </div>
  )
}
